module.exports = require('../../full/object/values');
